export function AccessDeniedPage() {
  const mspPortalUrl = import.meta.env.VITE_MSP_PORTAL_URL || 'https://dev.cloudincidents.se';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
      <div className="card w-full max-w-lg">
        <h1 className="text-2xl font-semibold">Access Denied</h1>
        <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">
          This portal is restricted to users with the SystemAdmin role.
        </p>
        <a
          className="mt-5 inline-block rounded bg-primary-700 px-4 py-2 text-sm font-medium text-white hover:bg-primary-800"
          href={mspPortalUrl}
        >
          Go to MSP Portal
        </a>
      </div>
    </div>
  );
}
